module.exports = __webpack_public_path__ + "media/images/sp/plans/mv_flower@3x-8ae48afeb43e4ab6a5529e709dd44e54.webp";